import { render, staticRenderFns } from "./medicalAestheticsDetail.vue?vue&type=template&id=0727e00a&scoped=true&"
import script from "./medicalAestheticsDetail.vue?vue&type=script&lang=js&"
export * from "./medicalAestheticsDetail.vue?vue&type=script&lang=js&"
import style0 from "./medicalAestheticsDetail.vue?vue&type=style&index=0&id=0727e00a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0727e00a",
  null
  
)

export default component.exports